export const appendTiaraSearchParams = (url = '') => {
  const hasQuery = url.includes('?') || url.includes('&')
  const sep = hasQuery ? '&' : '?'
  return `${url}${sep}t_src=keyword_ad&t_ch=gnb`
}
